export type AccountFlowView =
  | 'accountEntry'
  | 'accountPasswordLogin'
  | 'phoneBindEmail'
  | 'registerVerifyEmail'
  | 'thirdPartyBindEmail'
  | 'registerCreatePassword'
  | 'registerBindPhone'
  | 'resetVerifyEmail'
  | 'resetNewPassword'

export type AccountEntryResolution = 'accountPasswordLogin' | 'unregisteredAccount'
export type ThirdPartyRegisterInitialView =
  | 'registerVerifyEmail'
  | 'registerCreatePassword'
  | 'registerBindPhone'
  | null

const EMAIL_PATTERN = /^\w+([-.+]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/

export type AccountAuthTranslate = (key: string, values?: Array<string | number>) => string

export type ThirdPartyBindIdentity = {
  accountType?: string
  id?: string
  token?: string
}

const THIRD_PARTY_ACCOUNT_TYPES: Record<string, number> = {
  wechat: 352,
  weixin: 352,
  google: 381,
  gmail: 381,
  apple: 400,
  telegram: 402,
  linkedin: 403,
}

/** 将第三方回调类型转换为聚合登录接口所需的账号类型。 */
export const resolveThirdPartyAccountType = (value: string) => {
  const normalizedValue = value.trim().toLowerCase()
  if (/^\d+$/.test(normalizedValue)) return Number(normalizedValue)

  return THIRD_PARTY_ACCOUNT_TYPES[normalizedValue] || 0
}

export const isEmailAccount = (account: string) => EMAIL_PATTERN.test(account.trim())

export const validateAccountEntry = (account: string, t: AccountAuthTranslate) => {
  if (!account.trim()) {
    return t('83719')
  }

  return ''
}

export const resolveAccountEntryNextView = ({
  isRegistered,
}: {
  account: string
  isRegistered: boolean
}): AccountEntryResolution => {
  if (isRegistered) {
    return 'accountPasswordLogin'
  }

  return 'unregisteredAccount'
}

export const resolveThirdPartyRegisterInitialView = (loginType = '', email = ''): ThirdPartyRegisterInitialView => {
  const normalizedLoginType = loginType.toLowerCase()
  if (
    normalizedLoginType.includes('wechat') ||
    normalizedLoginType.includes('google') ||
    normalizedLoginType.includes('apple') ||
    normalizedLoginType.includes('telegram') ||
    normalizedLoginType.includes('linkedin')
  ) {
    return 'registerVerifyEmail'
  }

  return email.trim() ? 'registerVerifyEmail' : 'registerBindPhone'
}

export const validatePasswordPair = (password: string, confirmPassword: string, t: AccountAuthTranslate) => {
  if (!password || !confirmPassword) {
    return t('82415')
  }

  if (password !== confirmPassword) {
    return t('82930')
  }

  if (!/^\S{6,20}$/.test(password)) {
    return t('82415')
  }

  return ''
}

export const validateSinglePassword = (password: string, t: AccountAuthTranslate) => {
  if (!password.trim()) {
    return t('82415')
  }

  if (!/^\S{6,20}$/.test(password.trim())) {
    return t('82415')
  }

  return ''
}

export const validatePhoneInput = (phone: string, areaCode: string, t: AccountAuthTranslate) => {
  if (areaCode === '0086') {
    if (!/^[1][3-9][0-9]{9}$/.test(phone)) {
      return t('82408')
    }
  } else if (!/^.{5,20}$/.test(phone)) {
    return t('82408')
  }

  return ''
}

export const validateEmailValue = (email: string, t: AccountAuthTranslate, invalidMessage = t('83704')) => {
  if (!email.trim()) {
    return t('82411')
  }

  if (!EMAIL_PATTERN.test(email.trim())) {
    return invalidMessage
  }

  return ''
}
